import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Save } from "lucide-react";
import { PageHeader, Card, Field, TextArea, ImageUploader } from "@/components/admin/Primitives";

const PAGES = [
  { key: "home", label: "Home" },
  { key: "events", label: "Events" },
  { key: "blog", label: "Blog" },
  { key: "shop", label: "Shop" },
  { key: "gallery", label: "Gallery" },
  { key: "about", label: "About" },
  { key: "contact", label: "Contact" },
];

export default function SEO() {
  const [active, setActive] = useState("home");
  const [form, setForm] = useState({ page: "home", title: "", description: "", keywords: "", og_image: "" });
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get(`/seo/${active}`).then(({ data }) => setForm({ page: active, title: data.title || "", description: data.description || "", keywords: data.keywords || "", og_image: data.og_image || "" }));
  }, [active]);

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.put("/admin/seo", form);
      toast.success("SEO updated");
    } catch { toast.error("Failed"); } finally { setBusy(false); }
  };

  return (
    <div data-testid="admin-seo-page" className="text-white">
      <PageHeader title="SEO Configuration" subtitle="Per-page meta tags for search engines and social previews." />
      <div className="flex flex-wrap gap-2 mb-4">
        {PAGES.map((p) => (
          <button key={p.key} data-testid={`seo-tab-${p.key}`} onClick={() => setActive(p.key)} className={`px-4 py-2 rounded-full text-xs uppercase tracking-[0.12em] font-bold ${active === p.key ? "bg-[var(--pz-red)] text-white" : "border border-[var(--pz-line)] text-zinc-400 hover:border-[var(--pz-red)]"}`}>{p.label}</button>
        ))}
      </div>
      <Card>
        <form onSubmit={save} className="space-y-4">
          <Field label="Page title (browser tab + Google)" value={form.title} onChange={(v) => setForm({ ...form, title: v })} testid="seo-title" />
          <TextArea label="Meta description" rows={3} value={form.description} onChange={(v) => setForm({ ...form, description: v })} testid="seo-description" />
          <Field label="Keywords (comma separated)" value={form.keywords} onChange={(v) => setForm({ ...form, keywords: v })} testid="seo-keywords" />
          <ImageUploader value={form.og_image} onChange={(v) => setForm({ ...form, og_image: v })} testid="seo-og" label="Social share image" />
          <div className="flex justify-end">
            <button disabled={busy} data-testid="seo-save-btn" className="btn-red disabled:opacity-60"><Save className="h-4 w-4" /> {busy ? "Saving..." : "Save SEO"}</button>
          </div>
        </form>
      </Card>
    </div>
  );
}
